import React, { useState, useEffect } from "react";
import {
  Button,
  Box,
  TextField,
  FormControlLabel,
  Checkbox,
  Typography,
  Divider,
  Chip,
} from "@mui/material";
import Detail from "../../../main/detail/Detail";
import { useNavigate, useLocation } from "react-router-dom";
import { UseOrdergifts } from "./UseOrdergifts";
import ProgressCom from "../../../components/ProgressCom";
import { UseMyPC } from "../../../hooks/UseMyPC";
import { rsProgress, rsActiveMenu } from "../../../RecoilStates";
import { useRecoilState } from "recoil";
import SearchOrderGift from "./SearchOrderGift";
import { removeComma, toMoney } from "../../../util/Utils";
import CategoriesCondition from "./CategoriesCondition";
import BrandsCondition from "./BrandsCondition";
import GroupsCondition from "./GroupsCondition";
import ProductsCondition from "./ProductsCondition";
import useBreakpoints from "../../../hooks/useBreakpoints";

export default function AddOrderGift(props) {
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const location = useLocation();
  const navigate = useNavigate();
  const { validate, getOrdergiftsById, addOrdergifts } = UseOrdergifts();
  const [expanded, setExpanded] = useState();
  const [name, setName] = useState("");
  const [progress, setProgress] = useRecoilState(rsProgress);
  const exceptThisSymbols = ["e", "E", "+", "-", "."];
  const [state, setState] = useState({
    id: undefined,
    isActive: false,
    rowNO: undefined,
    giftName: undefined,
    giftID: undefined,
    description: undefined,
    minOrderItems: 0,
    minPayment: 0,
    brands: [],
    categories: [],
    groups: [],
    products: [],
    provinces: [],
  });
  const { isSmall } = useBreakpoints();

  const [errorState, setErrorState] = useState({
    // minOrderItems: false,
    // minPayment: false,
    giftName: false,
  });

  // useEffect(() => {
  //   if (name) {
  //     setState({ ...state, giftName: name });
  //   } else {
  //   }
  // }, [name]);

  return (
    <Detail
      breadChilds={{
        backButtonDef: {
          state: location.state,
          replace: true,
        },
        backURL: "/ordergifts",
        title: "محصولات",
        childs: [
          { name: msActiveMenu.pageTitle, url: "/ordergifts" },
          { name: "افزودن هدیه سفارش", url: "/ordergifts/addOrdergifts" },
        ],
      }}
    >
      <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={3}>
        <Box gridColumn={isSmall ? "span 12" : "span 6"}>
          <TextField
            value={state.giftName ? state.giftName : ""}
            label="نام هدیه"
            size="small"
            fullWidth
            // error={errorState.giftName}
            variant="outlined"
            onChange={(evt) => {
              setState({
                ...state,
                giftName: evt.target.value,
              });
            }}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Box>
        {!isSmall && <Box gridColumn="span 6"></Box>}
        <Box gridColumn={isSmall ? "span 12" : "span 7"}>
          <SearchOrderGift
            productID={state.id}
            name={name}
            productModel={state}
            setName={setName}
            setProductModel={setState}
            errorState={errorState}
          />
        </Box>
        {!isSmall && <Box gridColumn="span 5"></Box>}
        <Box gridColumn={isSmall ? "span 12" : "span 3"}>
          <TextField
            sx={{
              input: {
                textAlign: "center",
              },
            }}
            value={state.minPayment ? toMoney(state.minPayment) : ""}
            label="حداقل خرید (تومان)"
            size="small"
            // error={errorState.minPayment}
            variant="outlined"
            onKeyDown={(e) =>
              exceptThisSymbols.includes(e.key) && e.preventDefault()
            }
            onChange={(evt) => {
              if (evt.target.value) {
                const sanitizedValue = evt.target.value.replace(/[^0-9.]/g, "");
                setState({
                  ...state,
                  minPayment: removeComma(sanitizedValue),
                });
              } else {
                setState({
                  ...state,
                  minPayment: 0,
                });
              }
            }}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Box>
        {!isSmall && <Box gridColumn="span 9"></Box>}
        <Box gridColumn={isSmall ? "span 12" : "span 3"}>
          <TextField
            sx={{
              input: {
                textAlign: "center",
              },
            }}
            // error={errorState.minOrderItems}
            value={state.minOrderItems ? toMoney(state.minOrderItems) : ""}
            label="حداقل اقلام سفارش"
            size="small"
            variant="outlined"
            onKeyDown={(e) =>
              exceptThisSymbols.includes(e.key) && e.preventDefault()
            }
            onChange={(evt) => {
              if (evt.target.value) {
                const sanitizedValue = evt.target.value.replace(/[^0-9.]/g, "");

                setState({
                  ...state,
                  minOrderItems: removeComma(sanitizedValue),
                });
              } else {
                setState({
                  ...state,
                  minOrderItems: 0,
                });
              }
            }}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Box>
        {!isSmall && <Box gridColumn="span 8"></Box>}
        {/* <Box gridColumn={isSmall ? "span 12" : "span 3"}>
          <TextField
            sx={{
              input: {
                textAlign: "center",
              },
            }}
            value={state.rowNO ? state.rowNO : ""}
            label="ردیف"
            size="small"
            variant="outlined"
            onChange={(evt) => {
              setState({
                ...state,
                rowNO: evt.target.value,
              });
            }}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Box>
        <Box gridColumn="span 8"></Box> */}
        <Box gridColumn={isSmall ? "span 12" : "span 5"}>
          <TextField
            multiline
            rows={3}
            fullWidth
            value={state.description ? state.description : ""}
            label="توضیحات"
            size="small"
            variant="outlined"
            onChange={(evt) => {
              setState({
                ...state,
                description: evt.target.value,
              });
            }}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Box>
        {!isSmall && <Box gridColumn="span 7"></Box>}
        <Box
          sx={{ display: "flex", alignItems: "center", gap: 1 }}
          gridColumn={isSmall ? "span 12" : "span 2"}
        >
          <Typography variant="subtitle2">وضعیت : </Typography>
          <FormControlLabel
            control={
              <Checkbox
                checked={state.isActive}
                onChange={(event) =>
                  setState({
                    ...state,
                    isActive: event.target.checked,
                  })
                }
              />
            }
            label="فعال"
          />
        </Box>
        {!isSmall && <Box gridColumn="span 10"></Box>}
        <Box
          sx={{ display: "flex", justifyContent: "center", gap: 1 }}
          gridColumn="span 12"
        >
          <Button
            variant="contained"
            onClick={() => {
              if (validate(state, setErrorState) == 200) {
                let sendModel = {
                  // id: 0,
                  giftID: state.giftID,
                  giftName: state.giftName,
                  isActive: state.isActive,
                  rowNO: state.rowNO ? Number(state.rowNO) : 0,
                  minPayment: state.minPayment ? Number(state.minPayment) : 0,
                  minOrderItems: state.minOrderItems
                    ? Number(state.minOrderItems)
                    : 0,
                  description: state.description ? state.description : "",
                };
                setProgress(true);
                addOrdergifts(sendModel, (callback) => {
                  setState(callback);
                  setProgress(false);
                });
              }
            }}
          >
            ثبت
          </Button>
        </Box>
      </Box>
      <CategoriesCondition
        callback={(giftID) => {
          getOrdergiftsById(giftID, (GiftDetails) => {
            setState(GiftDetails);
          });
        }}
        giftID={state.id}
        state={state}
        setState={setState}
        expanded={expanded}
        setExpanded={setExpanded}
      />
      <BrandsCondition
        callback={(giftID) => {
          getOrdergiftsById(giftID, (GiftDetails) => {
            setState(GiftDetails);
          });
        }}
        giftID={state.id}
        state={state}
        setState={setState}
        expanded={expanded}
        setExpanded={setExpanded}
      />
      <GroupsCondition
        callback={(giftID) => {
          getOrdergiftsById(giftID, (GiftDetails) => {
            setState(GiftDetails);
          });
        }}
        giftID={state.id}
        state={state}
        setState={setState}
        expanded={expanded}
        setExpanded={setExpanded}
      />
      <ProductsCondition
        callback={(giftID) => {
          getOrdergiftsById(giftID, (GiftDetails) => {
            setState(GiftDetails);
          });
        }}
        giftID={state.id}
        state={state}
        setState={setState}
        expanded={expanded}
        setExpanded={setExpanded}
      />
    </Detail>
  );
}
